import React, { useEffect, useState, useCallback } from 'react';

import { updateCAPA, viewCAPA } from '../../../../services/CAPAService';

import { BackButton } from '../../../common/button/back-button/BackButton';
import { BreadCrumbTrail } from '../../../common/breadcrumb-trail/BreadcrumbTrail';
import { CAPAReviewGeneralTab } from '../create/CAPAReviewGeneralTab';

import '../create/CAPAReviewCreate.css';

export const CAPAReviewEdit = ({ context, navigateTo, showToaster, setSpinnerText, toolTipsEnabled }) => {
  const [capa, setCapa] = useState(undefined);

  const retrieveCapa = useCallback(
    async (externalReference) => {
      const [data, error] = await viewCAPA(context.username, externalReference);
      if (data) {
        if (data.responseStatus === 'Success') {
          setCapa(data.viewCAPAVO);
          showToaster({
            responseStatus: 'Success',
            responseMessage: 'CAPA Information Retrieved',
          });
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    },
    [context.username, setSpinnerText, showToaster]
  );

  useEffect(() => {
    if (context.additionalContext) {
      retrieveCapa(context.additionalContext.externalReference);
    }
  }, [context.additionalContext, retrieveCapa]);

  const handleUpdate = async (capaToUpdate) => {
    setSpinnerText('Updating CAPA');
    const [data, error] = await updateCAPA(context.username, capaToUpdate);
    if (data) {
      if (data.responseStatus === 'Success') {
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'CAPA Updated',
        });
        await navigateTo('capaReviewsTable');
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  return (
    <div className="clients-create-container">
      <div className="clients-create-header-container">
        <BackButton onClick={() => navigateTo('capaReviewsTable')} />
        <h2>Edit / View CAPA Review</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div className="clients-create-tab general active-tab">General</div>
            </div>

            <div className="clients-create-tab-content capaReviewCreateGeneral">
              <CAPAReviewGeneralTab
                capa={capa}
                context={context}
                navigateTo={navigateTo}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                toolTipsEnabled={toolTipsEnabled}
                handleUpdate={handleUpdate}
                editMode
              />
            </div>
          </div>
        </div>

        <div className="wizard-breadcrumb-container">
          <BreadCrumbTrail context={context} navigateTo={navigateTo} />
        </div>
      </div>
    </div>
  );
};
